var React = require('react');

function Quotation (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},[React.createElement("path",{"d":"m26.391 74.078c1.7461-0.82422 3.543-3.6328 4.4141-5.9258 0.875-2.293 1.1133-5.2266 1.1133-9.8203h-15.254c-2.3008 0-4.1641-1.8242-4.1641-4.1758v-20.812c0-2.3047 1.8867-4.1758 4.1523-4.1758h25.027c2.293 0 4.1523 1.8828 4.1523 4.1367v20.918c0 6.9688-1.9414 12.695-5.6914 17.242s-8.8594 6.6016-13.75 7.7031z","key":0}),React.createElement("path",{"d":"m68.055 74.078c1.7461-0.82422 3.5469-3.6328 4.418-5.9258 0.875-2.293 1.1133-5.2266 1.1094-9.8203h-15.25c-2.3008 0-4.1641-1.8242-4.1641-4.1758v-20.812c0-2.3047 1.8867-4.1758 4.1523-4.1758h25.027c2.293 0 4.1523 1.8828 4.1523 4.1367v20.918c0 6.9688-1.9453 12.695-5.6914 17.242-3.75 4.5469-8.8633 6.6016-13.754 7.7031z","key":1})]));
}

Quotation.defaultProps = {"width":"100%","height":"100%","version":"1.1","viewBox":"0 0 100 100"};

module.exports = Quotation;

Quotation.default = Quotation;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/assets/quotation.svg
// module id = 419
// module chunks = 0